// "Your rights" tip for a shelf label that doesn't add up (shelf-label
// proposal 2). Deliberately cautious: it names the state when the state has a
// general unit-pricing law, and otherwise just says what any shopper can do.
// It makes no refund or legal-remedy claims. Wording needs a lawyer's review
// before any state-specific remedies are added.

/**
 * US states with mandatory (general) unit-pricing laws for many retailers,
 * per NIST Handbook 130 / the NIST unit pricing guide. Exemptions vary by state.
 */
export const UNIT_PRICING_STATES: Record<string, string> = {
  CT: 'Connecticut',
  MA: 'Massachusetts',
  MD: 'Maryland',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NY: 'New York',
  OR: 'Oregon',
  RI: 'Rhode Island',
  VT: 'Vermont',
};

/** Two-letter US state from an address like "490 Post St, San Francisco, CA 94102", or null. */
export function storeStateCode(address: string | null | undefined): string | null {
  if (!address) return null;
  const match = address.match(/\b([A-Z]{2})\s+\d{5}(?:-\d{4})?\b/);
  return match ? match[1] : null;
}

/** The state's name when it has a general unit-pricing law, otherwise null. */
export function unitPricingLawState(address: string | null | undefined): string | null {
  const code = storeStateCode(address);
  return code ? UNIT_PRICING_STATES[code] ?? null : null;
}
